import axios from './axios'
import qs from "qs";

function service(endpoint) {
    function realized(id) {
        return axios.post(`${endpoint}/${id}/realized`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchLeadAction(data) {
        return axios.get(`${endpoint}/lead`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        realized,
        fetchLeadAction
    }
}

export default service
